import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const guarantees = ['Instant Download', 'No Subscription', 'Lifetime Access', '7-Day Guarantee'];
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-20 pt-5" data-id="element-104" data-mp="9llb731mq8q5">
      <div className="mx-auto max-w-4xl text-center" data-id="element-105" data-mp="4lyx6rdz8oga">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="font-display text-[2.6rem] font-black leading-[1.02] tracking-tight text-ink sm:text-6xl md:text-[4.5rem]" data-id="element-106" data-mp="4njqkdok21ck">
          Solve a Full Year of Math Class in Just{' '}
          <span className="italic text-brand" data-id="element-107" data-mp="ncq1vfn0rqoc">5 Minutes</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1,
        ease: 'easeOut'
      }} className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-ink/60 sm:text-lg" data-id="element-108" data-mp="3d1ihv20l0yjq">
          Join 2,000+ math teachers who stopped improvising. Walk into every
          class with everything ready to teach, solve, and inspire.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.18,
        ease: 'easeOut'
      }} className="mx-auto mt-2 max-w-2xl pb-5 pt-2.5 sm:mt-8" data-id="element-109" data-mp="399jmzcfv4d5l">
          <img src="https://cdn.magicpatterns.com/uploads/aJ5hqaN3VeNSMELHiz1KVt/5d7d771c-a6b7-407e-9daf-232b532d381a.webp" alt="The Math Ready pack shown across printed volumes, desktop, tablet and phone" className="w-full" data-id="element-110" data-mp="358hlsq2dxr0z" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.28,
        ease: 'easeOut'
      }} className="-mt-2 sm:mt-8" data-id="element-111" data-mp="2hj5clq725iyo">
          <CtaButton href="#offer" data-id="element-112" data-mp="s2jjlmv9pier" />
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-ink/50 sm:text-sm" data-id="element-113" data-mp="s3mbny4btqw9">
            {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-114" data-mp="id02omr47ymj" data-mpi={index}>
                <span data-id="element-115" data-mp="ddnhs7jt11ml">{item}</span>
                {index < guarantees.length - 1 && <span aria-hidden="true" className="text-ink/25" data-id="element-116" data-mp="1b0njrrt6g74f">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}